module.exports = __webpack_public_path__ + "static/media/activitiesdetailarrow.ae5c49f8.svg";